import { Headline } from "@App/Components/atoms/common/Headline";
import { useTranslation } from "react-i18next";

export function VehicleReturnTOS() {
  const { t } = useTranslation();
  return (
    <section id={"extra-cost-tos"} className={"container py-5 flex flex-col gap-3 text-sm"}>
      <Headline type={"h2"}>{t("booking.vehicleReturn.tos.headline")}</Headline>
      <p className={"font-bold"}>{t("booking.vehicleReturn.tos.subheadline")}</p>
      <p>{t("booking.vehicleReturn.tos.text")}</p>
    </section>
  );
}
